import TypographyTitle from 'common/components/Typography/Title';
import TypographyDescription from 'common/components/Typography/Description';
import {
  Packaging,
  PackagingHead,
  PackagingContent,
} from '../pricingPage.style';
import { Box, CardContent, Divider, Typography } from '@mui/material';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { saasModernTheme } from 'common/theme/saasModern';
import { gradientBoxStyleWithHoverAnimation } from 'utils/gradianStyle';
import STGradiantChip from 'common/STGradiantChip/STGradantChip';
import STGradiantButton from 'common/STGradiantButton/STGradiantButton';
import { useTranslations } from 'hooks/useTranslations';
const PurchaseCredit = ({ data }) => {
  const { t } = useTranslations();
  return (
    <Packaging>
      <PackagingHead>
        <TypographyTitle color={'black'}>{data.packaging_title}</TypographyTitle>
        <TypographyDescription>
          <PrismicRichText field={data.packaging_desciption} />
        </TypographyDescription>
      </PackagingHead>

      <PackagingContent>
        {data.packagings.map((packaging, index) => (
          <CardContent
            sx={{
              ...gradientBoxStyleWithHoverAnimation(
                index === 0
                  ? 'BOTTOM_LEFT'
                  : index === 1
                    ? 'TOP_LEFT'
                    : 'BOTTOM_RIGHT',
              ),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                opacity: packaging.info_percentage !== '0%' ? 1 : 0,
              }}
            >
              <STGradiantChip
                disabled
                variant={'outlined'}
                label={packaging.info_percentage}
                sx={{
                  marginInline: 'auto',
                  fontSize: '14px',
                  fontWeight: '700',
                  height: '24px',
                  width: 80,
                  color: saasModernTheme.colors.black,
                  textTransform: 'uppercase',
                }}
              />
            </Box>
            <Box>
              <Typography
                variant="h1"
                component="div"
                textTransform={'none'}
                style={{
                  fontSize: 36,
                  fontWeight: '900',
                }}
              >
                {packaging.token}
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="h3"
                component="div"
                textTransform={'none'}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: saasModernTheme.colors.grayBorder,
                }}
              >
                {t('pricing.token.swiftask')}
              </Typography>
            </Box>
            <Divider
              sx={{
                width: 50,
                ml: 1,
                border: `1px solid gray`,
              }}
            />
            <Box>
              <Typography variant="h1" component="div">
                €{packaging.price}
              </Typography>
            </Box>

            <STGradiantButton
              sx={{
                width: '100%',
                height: '40px',
                zIndex: 9999,
              }}
              href="https://app.swiftask.ai"
              variant={index === 1 ? 'contained' : 'outlined'}
              label={packaging.label_button_subcription}
            />
          </CardContent>
        ))}
      </PackagingContent>
    </Packaging>
  );
};
export default PurchaseCredit;
